import { APISchema } from "@/types/response";
import { createRequestClient } from "@/utils/request";
import { getToken } from "@/utils/auth";

interface requestRecord {
  data: any;
}
interface responseRecord {
  msg: string;
  code: number;
}
interface basicAPISchema extends APISchema {
  queryUser: {
    request: requestRecord;
    response: responseRecord;
  };
  exportUser: {
    request: requestRecord;
    response: responseRecord;
  };
  changeStatus: {
    request: requestRecord;
    response: responseRecord;
  };
  queryRules: {
    request: requestRecord;
    response: responseRecord;
  };
  queryGroupList: {
    request: {};
    response: responseRecord;
  };
  addUser: {
    request: {};
    response: responseRecord;
  };
  updateUser: {
    request: {};
    response: responseRecord;
  };
  queryUserDetail: {
    request: {};
    response: responseRecord;
  };
  setUserPassword: {
    request: {};
    response: responseRecord;
  };
  removeUser: {
    request: {};
    response: responseRecord;
  };
  queryPermission: {
    request: {};
    response: responseRecord;
  };
  dataScope: {
    request: {};
    response: responseRecord;
  };
  queryDownloadFile: {
    request: {};
    response: responseRecord;
  };
}

const HOST = process.env.VUE_APP_API;
const token = getToken();
const API = createRequestClient<basicAPISchema>({
  baseURL: HOST,
  headers: {
    Authorization: `Bearer ${token}`,
  },
  apis: {
    queryUser: "GET /system/user/list",
    exportUser: "GET /system/user/export",
    changeStatus: "POST /system/user/changeStatus",
    queryRules: "GET /system/user/",
    queryGroupList: "GET /barrack/armyUnit/treeselect",
    addUser: "POST /system/user/add",
    updateUser: "POST /system/user/edit",
    queryUserDetail: "GET /system/user/:id",
    removeUser: "POST /system/user/:id",
    setUserPassword: "POST /system/user/resetPwd",
    dataScope: "POST /system/user/dataScope",
    queryPermission: "GET /system/user/userUnitTreeSelect/:id",
    queryDownloadFile: "POST /barrack/taskCenter/fetchDownTask"
  },
});
export { API };
